var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.33 44.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#393a3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.39,0c21.13,23.67,29.69,24.51,41.3,15.56C26,20.45,15.7,12.74.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.71,16c.32,5.2-5.47,20.56-1.88,28.46-4.88-5-2.22-18-3.44-22.75A26.64,26.64,0,0,0,41.71,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.24,6.83a3.21,3.21,0,0,0-4.33-1.2,2.43,2.43,0,0,0-.54.52,9,9,0,0,1,1.1.51,7.82,7.82,0,0,1,3.83,4.22A3.39,3.39,0,0,0,42.24,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.69,7.66c4.9,3.08,19.58,9.65,34.64,2.52C43.94,18.17,29.64,15.92,19.69,7.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.2,
    cy: 40.91,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.76,
    cy: 43.79,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.87,4.81a.9.9,0,1,1,1,.78A.88.88,0,0,1,1.87,4.81Zm-1.08-2a.7.7,0,0,0,.6-.78.69.69,0,0,0-.78-.61.69.69,0,0,0-.6.78A.7.7,0,0,0,.79,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.92,37.8a1.46,1.46,0,0,1-.86.26,1.07,1.07,0,0,1-.93-.43,1.93,1.93,0,0,1-.32-1.22,2.07,2.07,0,0,1,.31-1.21,1.07,1.07,0,0,1,.94-.43,1.74,1.74,0,0,1,.45.06,1.42,1.42,0,0,1,.37.15l-.13.29a1.37,1.37,0,0,0-.69-.18.73.73,0,0,0-.65.32,1.86,1.86,0,0,0-.21,1c0,.88.28,1.32.86,1.32a1.49,1.49,0,0,0,.75-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.5,38H13.84V34.83h1.64v.32H14.21v1h1.22v.32H14.21v1.22H15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.65,38h-.46l-.93-1.44h-.41V38h-.37V34.83h.9a1,1,0,0,1,.71.22.81.81,0,0,1,.07,1.12,1,1,0,0,1-.52.31Zm-1.8-1.76h.46a.73.73,0,0,0,.48-.16.52.52,0,0,0,.18-.4c0-.35-.22-.53-.65-.53h-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.16,37.8a1.48,1.48,0,0,1-.86.26,1.1,1.1,0,0,1-.94-.43A2,2,0,0,1,25,36.41a2.14,2.14,0,0,1,.31-1.21,1.08,1.08,0,0,1,.95-.43,1.74,1.74,0,0,1,.45.06,1.22,1.22,0,0,1,.36.15l-.12.29a1.37,1.37,0,0,0-.69-.18.73.73,0,0,0-.65.32,1.85,1.85,0,0,0-.22,1q0,1.32.87,1.32a1.49,1.49,0,0,0,.75-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.56,35.18a1.55,1.55,0,0,0-.54-.1.84.84,0,0,0-.47.13.45.45,0,0,0-.18.38c0,.19.16.36.48.5l.46.23a1.13,1.13,0,0,1,.23.17.83.83,0,0,1,.19.26.88.88,0,0,1,.07.33.9.9,0,0,1-.31.72,1.13,1.13,0,0,1-.74.26,1.46,1.46,0,0,1-.71-.17l.07-.31a1.62,1.62,0,0,0,.64.16.75.75,0,0,0,.5-.16.62.62,0,0,0,.07-.81,1.81,1.81,0,0,0-.46-.3l-.44-.21a.94.94,0,0,1-.2-.16.57.57,0,0,1-.15-.23A.6.6,0,0,1,31,35.6.72.72,0,0,1,31.3,35a1.08,1.08,0,0,1,.71-.22,2.28,2.28,0,0,1,.63.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,23.23v1.09a.14.14,0,0,1,0,.07l-.46,1.2a.19.19,0,0,1-.18.13h-3a.2.2,0,0,0-.2.2v4.95a.2.2,0,0,0,.2.2h3.41a.21.21,0,0,1,.21.2v2.28a.21.21,0,0,1-.21.2H9.15a1.28,1.28,0,0,1-1.34-1.33V24.36A1.28,1.28,0,0,1,9.15,23h5.62A.21.21,0,0,1,15,23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.25,30.61v2.94a.2.2,0,0,1-.2.2H16.1a.21.21,0,0,1-.21-.2V23.23a.21.21,0,0,1,.21-.2h6.49a1.28,1.28,0,0,1,1.35,1.33v4.7a1.3,1.3,0,0,1-1.35,1.35H19.45A.2.2,0,0,0,19.25,30.61Zm.2-2.88h.93a.2.2,0,0,0,.2-.2V25.92a.2.2,0,0,0-.2-.2h-.93a.2.2,0,0,0-.2.2v1.61A.2.2,0,0,0,19.45,27.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.35,23.2l1.47,9.2v1.15a.2.2,0,0,1-.2.2h-3a.2.2,0,0,1-.2-.18l-.16-1.8a.2.2,0,0,0-.2-.18H28a.2.2,0,0,0-.2.18l-.18,1.8a.2.2,0,0,1-.2.18H24.45a.21.21,0,0,1-.21-.2V32.4l1.47-9.2a.2.2,0,0,1,.2-.17h5.23A.2.2,0,0,1,31.35,23.2ZM29,28.69l-.26-2.78a.21.21,0,0,0-.21-.19h0a.21.21,0,0,0-.2.19l-.26,2.78a.19.19,0,0,0,.2.22h.53A.2.2,0,0,0,29,28.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpa);
export default __webpack_public_path__ + "static/media/cpa.c592e73eaf5e86df4809b7a79d45eb0c.svg";
export { ForwardRef as ReactComponent };